/** **************************** Export Create deposite Types ****************************** */
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_FAILURE = "NOTIFICATION_FAILURE";
export const NOTIFICATION_REQUEST = "NOTIFICATION_REQUEST";